import React from "react";
import ReactDOM from "react-dom";
import AddCatgeory from "./popup/addCatgeory";
import AddCustomAttr from "./popup/addCustomAttr";
import SelectedCustomAttributes from "./selectedCustomAttributes";

import { hot } from "react-hot-loader/root";
import { withTranslation } from 'react-i18next';

class CustomWorkstreamsAttr extends React.Component {
  constructor(props) {
    super(props);
    this.addCustomCatgeory = this.addCustomCatgeory.bind(this);
    this.saveCatgeory = this.saveCatgeory.bind(this);
    this.cancelBoxaddCatgeory = this.cancelBoxaddCatgeory.bind(this);
    this.addCustomAttr = this.addCustomAttr.bind(this);
    this.saveCustomAttr = this.saveCustomAttr.bind(this);
    this.cancelBoxCustomAttr = this.cancelBoxCustomAttr.bind(this);
  }

  addCustomCatgeory() {
    const property = {
      /* pass json to AddCatgeory componet */
      title: "Add Category", // title of the popup
      callBack: this.saveCatgeory, // save/callback methord
      cancel: this.cancelBoxaddCatgeory, // cancel/close button
      name: "", // Category Name in case of edit
      description: "" // Description in case of edit
    };
    ReactDOM.render(
      <AddCatgeory property={property} />,
      document.getElementById("addCatgeory")
    );
    addCatgeory.dialog('open');
  }

  saveCatgeory(data) {
    const { teamId } = this.props.CustomAttr;
    const { object_type } = this.props.CustomAttr;
    const { actions } = this.props;
    showLoaderWidget($("#content"));
    const params = {
      name: data.name,
      description: data.description,
      object_type,
      object_id: teamId
    };
    $.post(
      `${wbConfig.baseUrl}/activity/addCustomCategory`,
      params,
      (response, status) => {
        if (status == "success") {
          removeLoaderWidget();
          actions.customAddCategory(response.data);
        }
      }
    );
    this.forceUpdate();
    this.cancelBoxaddCatgeory();
  }

  cancelBoxaddCatgeory() {
    if (document.getElementById("addCatgeory")) {
      ReactDOM.unmountComponentAtNode(document.getElementById("addCatgeory"));
    }
    $(addCatgeory).dialog("close");
  }

  addCustomAttr() {
    const { t } = this.props;
    const tableProps = {
      title: t("Add a Custom Workstream Attribute"),
      buttons: {
        save: {
          name: t("Save"),
          color: "red",
          callBack: this.saveCustomAttr
        },
        calsal: {
          name: "cale",
          color: "black",
          callBack: this.cancelBoxCustomAttr
        }
      },
      fields: {},
      type: 2,
      category: this.props.CustomAttr.category,
      name: "",
      categoryName: "",
      cat_id: "",
      field_type_id: "",

      editPermission: "",
      viewPermission: "",
      selEditId: [],
      selEdit: [],
      selVisibId: [],
      selVisib: [],
      id: "",
      values: []
    };

    ReactDOM.render(
      <AddCustomAttr
        cancel={this.cancelBoxCustomAttr}
        callBack={this.saveCatgeory}
        tableProps={tableProps}
      />,
      document.getElementById("addCustomAttr")
    );
    addCustomAttr.dialog('open');
  }

  saveCustomAttr(data) {
    const loginId = this.props.CustomAttr.loginUserID;
    const { teamId } = this.props.CustomAttr;
    this.cancelBoxCustomAttr(addCustomAttr);
    const { object_type } = this.props.CustomAttr;
    if (data != "") {
      const { actions } = this.props;
      const name = "";
      const field_type_id = "";
      const object_id = teamId;
      const cat_id = "";
      const categoryName = "";
      const created_by = loginId;
      const params = {
        object_type,
        object_id,
        name: data.attributeName,
        field_type_id: data.selshowFieldId,
        cat_id: data.selCatId,
        categoryName: data.selCat,
        created_by,
        field_type: data.selshowFieldVal
      };
      if (data.selshowFieldId == 3 || data.selshowFieldId == 4) {
        params.value = data.values;
      }
      if ($.ajaxSetup().data.YII_CSRF_TOKEN) {
        params.YII_CSRF_TOKEN = $.ajaxSetup().data.YII_CSRF_TOKEN;
      }
      $.post(
        `${wbConfig.baseUrl}/activity/addCustomAttributes`,
        params,
        (response, status) => {
          if (status == "success") {
            response.data.field_type = data.selshowFieldVal;
            actions.customAddAttributes(data.selCatId, response.data);
          }
        }
      );
    }
  }

  cancelBoxCustomAttr() {
    if (document.getElementById("addCustomAttr")) {
      ReactDOM.unmountComponentAtNode(document.getElementById("addCustomAttr"));
    }
    $(addCustomAttr).dialog("close");
  }

  render() {
    const { t } = this.props;
    // console.log(this.props);console.log("this.props");
    return (
      <div>
        <div className="butWrap">
          <div className="btnAddCustom" onClick={e => this.addCustomAttr(e)}>
            {t("Add Custom Attribute")}
          </div>
          <div className="btnAddGroup" onClick={e => this.addCustomCatgeory(e)}>
          {t("Add Category")}
          </div>
        </div>

        <div>
          <SelectedCustomAttributes attrs={this.props} />
        </div>
      </div>
    );
  }
}
export default hot(withTranslation()(CustomWorkstreamsAttr));
